<template>
  <div id="app">
    <Why-header />
    <router-view />
    <Why-footer />
  </div>
</template>

<script>
import WhyHeader from '@/components/WhyHeader'
import WhyFooter from '@/components/WhyFooter'

export default {
  name: 'App',
  components: {
    WhyHeader,
    WhyFooter
  }
}
</script>

<style lang="scss">
#app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}
</style>